export const apiErrors: Record<string, { en: string; hu: string }> = {
  auth_rate_limited: {
    en: 'Too many requests. Wait for the retry delay before trying again.',
    hu: 'Túl sok kérés. A jelzett várakozási idő után próbálja újra.',
  },
  invalid_code_format: { en: 'Enter the six-digit sign-in code.', hu: 'Adja meg a hatjegyű bejelentkezési kódot.' },
  ticket_preparation_conflict: {
    en: 'This draft or template changed. Compare with the server before saving.',
    hu: 'A piszkozatot vagy sablont módosították. Mentés előtt hasonlítsa össze a szerveradatokkal.',
  },
  ticket_preparation_deleted: {
    en: 'This item was deleted or published.',
    hu: 'Ezt az elemet törölték vagy közzétették.',
  },
  invalid_preparation: {
    en: 'Enter a draft or template name of at most 512 characters.',
    hu: 'Adjon meg legfeljebb 512 karakteres piszkozat- vagy sablonnevet.',
  },
  ticket_project_required: { en: 'Choose a project before publishing.', hu: 'Közzététel előtt válasszon projektet.' },
  ticket_conflict: {
    en: 'Ticket changed on the server. Reload it and resolve the conflict.',
    hu: 'A hibajegy a szerveren időközben megváltozott. Töltse újra és oldja fel az ütközést.',
  },
  ticket_not_found: { en: 'The ticket was not found.', hu: 'A hibajegy nem található.' },
  invalid_ticket_id: { en: 'Enter a valid ticket ID.', hu: 'Adjon meg érvényes hibajegy-azonosítót.' },
  invalid_ticket_name: { en: 'Enter a valid ticket name.', hu: 'Adjon meg érvényes hibajegy-nevet.' },
  invalid_ticket_state: { en: 'Choose a valid ticket state.', hu: 'Válasszon érvényes hibajegyállapotot.' },
  invalid_ticket_priority: { en: 'Choose a valid ticket priority.', hu: 'Válasszon érvényes prioritást.' },
  ticket_project_forbidden: {
    en: 'You do not have access to this project.',
    hu: 'Nincs hozzáférése ehhez a projekthez.',
  },
  ticket_project_invalid: {
    en: 'Choose a project from this organisation.',
    hu: 'A szervezethez tartozó projektet válasszon.',
  },
  invalid_ticket_comment: { en: 'Enter a valid comment.', hu: 'Adjon meg érvényes megjegyzést.' },
  media_hash_mismatch: {
    en: 'The uploaded file checksum does not match.',
    hu: 'A feltöltött fájl ellenőrzőösszege nem egyezik.',
  },
  media_upload_not_found: {
    en: 'The media upload was not found or expired.',
    hu: 'A médiafeltöltés nem található vagy lejárt.',
  },
  invalid_media_kind: { en: 'Choose a supported media type.', hu: 'Válasszon támogatott médiatípust.' },
  invalid_blueprint_name: { en: 'Enter a valid blueprint name.', hu: 'Adjon meg érvényes tervrajznevet.' },
  invalid_blueprint_revision: { en: 'Enter a valid blueprint revision.', hu: 'Adjon meg érvényes tervrajz-revíziót.' },
  blueprint_media_invalid: {
    en: 'Choose a completed PDF blueprint upload.',
    hu: 'Befejezett PDF tervrajzfeltöltést válasszon.',
  },
  blueprint_revision_invalid: {
    en: 'Choose a blueprint revision from the ticket project.',
    hu: 'A hibajegy projektjéhez tartozó tervrajz-revíziót válasszon.',
  },
  invalid_report_format: {
    en: 'Choose PDF, DOCX or XLSX report format.',
    hu: 'PDF, DOCX vagy XLSX riportformátumot válasszon.',
  },
  ticket_reset_required: {
    en: 'Ticket synchronization must be bootstrapped again.',
    hu: 'A hibajegy-szinkronizálást újra kell inicializálni.',
  },
  internal_error: { en: 'An unexpected error occurred.', hu: 'Váratlan hiba történt.' },
  forbidden: {
    en: 'You do not have permission to perform this operation.',
    hu: 'Nincs jogosultsága a művelet végrehajtásához.',
  },
  invalid_session: {
    en: 'Your session is no longer valid. Sign in again.',
    hu: 'A munkamenet már nem érvényes. Jelentkezzen be újra.',
  },
  invalid_login_code: { en: 'The sign-in code is invalid or expired.', hu: 'A bejelentkezési kód hibás vagy lejárt.' },
  invalid_email: { en: 'Enter a valid e-mail address.', hu: 'Adjon meg érvényes e-mail-címet.' },
  invalid_company_name: { en: 'Enter a valid company name.', hu: 'Adjon meg érvényes vállalatnevet.' },
  invalid_dates: { en: 'Check the entered dates.', hu: 'Ellenőrizze a megadott dátumokat.' },
  invalid_project_dates: {
    en: 'Project end date cannot be before the start date.',
    hu: 'A projekt befejezési dátuma nem lehet korábbi a kezdő dátumnál.',
  },
  invalid_project_status: { en: 'Choose a valid project status.', hu: 'Válasszon érvényes projektállapotot.' },
  invalid_contractor_type: { en: 'Choose a valid contractor type.', hu: 'Válasszon érvényes vállalkozótípust.' },
  invalid_contractor_role: { en: 'Choose a valid contractor role.', hu: 'Válasszon érvényes vállalkozói szerepkört.' },
  contractor_role_mismatch: {
    en: 'The contractor type is not compatible with the selected project role.',
    hu: 'A vállalkozó típusa nem kompatibilis a kiválasztott projekt-szerepkörrel.',
  },
  invalid_parent_contractor: {
    en: 'Choose a general contractor from the same project.',
    hu: 'Ugyanahhoz a projekthez tartozó fővállalkozót válasszon.',
  },
  invalid_parent_location: {
    en: 'Choose a parent location from the same project.',
    hu: 'Ugyanahhoz a projekthez tartozó szülő helyszínt válasszon.',
  },
  contact_contractor_not_on_project: {
    en: "Assign the contact's contractor to the project first.",
    hu: 'Először rendelje a kapcsolattartó vállalkozóját a projekthez.',
  },
  invalid_user_account: {
    en: 'Choose a user account from this organisation.',
    hu: 'A szervezethez tartozó felhasználói fiókot válasszon.',
  },
  master_data_forbidden: {
    en: "You do not have access to this organisation's master data.",
    hu: 'Nincs hozzáférése ennek a szervezetnek a törzsadataihoz.',
  },
  organisation_not_found: { en: 'The organisation was not found.', hu: 'A szervezet nem található.' },
  organisation_not_active: { en: 'Choose an active organisation.', hu: 'Válasszon aktív szervezetet.' },
  organisation_deleted: { en: 'Deleted organisations cannot be edited.', hu: 'Törölt szervezet nem szerkeszthető.' },
  licence_not_found: { en: 'The licence was not found.', hu: 'A licenc nem található.' },
  licence_not_active: { en: 'The licence is not active.', hu: 'A licenc nem aktív.' },
  seat_limit_reached: {
    en: 'All available device seats are in use.',
    hu: 'Minden rendelkezésre álló eszközhely foglalt.',
  },
  member_device_limit_reached: {
    en: 'This user has reached the allowed device limit.',
    hu: 'A felhasználó elérte az engedélyezett eszközlimitet.',
  },
  invalid_activation_code: {
    en: 'The activation code or organisation membership is not valid.',
    hu: 'Az aktiválókód vagy a szervezeti tagság nem érvényes.',
  },
  invalid_invitation: { en: 'The invitation is invalid or expired.', hu: 'A meghívó hibás vagy lejárt.' },
  invalid_invitation_role: { en: 'Choose a valid invitation role.', hu: 'Válasszon érvényes meghívási szerepkört.' },
  tutorial_edit_forbidden: {
    en: 'Only Innozenit administrators can edit tutorial content.',
    hu: 'Az oktatóanyag tartalmát csak Innozenit rendszergazda szerkesztheti.',
  },
  invalid_tutorial_title: {
    en: 'Enter a valid tutorial title in both languages.',
    hu: 'Adjon meg érvényes oktatóanyag-címet mindkét nyelven.',
  },
  invalid_tutorial_status: {
    en: 'Choose Draft or Published status.',
    hu: 'Válasszon Piszkozat vagy Közzétett állapotot.',
  },
  tutorial_content_too_large: { en: 'Tutorial content is too large.', hu: 'Az oktatóanyag tartalma túl nagy.' },
  account_disabled: { en: 'This account is disabled.', hu: 'Ez a felhasználói fiók le van tiltva.' },
  activation_not_found: { en: 'Activation was not found.', hu: 'Az aktiválás nem található.' },
  activation_not_valid: { en: 'The activation is no longer valid.', hu: 'Az aktiválás már nem érvényes.' },
  code_not_applicable: {
    en: 'This licence does not use an activation code.',
    hu: 'Ehhez a licenchez nem használható aktiválókód.',
  },
  company_not_found: { en: 'The company was not found.', hu: 'A vállalat nem található.' },
  grant_not_found: {
    en: 'The requested configuration grant was not found.',
    hu: 'A kért konfigurációs jogosultság nem található.',
  },
  invalid_configuration: { en: 'The configuration is invalid.', hu: 'A konfiguráció érvénytelen.' },
  invalid_configuration_token: { en: 'The configuration token is invalid.', hu: 'A konfigurációs token érvénytelen.' },
  invalid_device_key: { en: 'The device key is invalid.', hu: 'Az eszközkulcs érvénytelen.' },
  invalid_device_proof: { en: 'The device proof is invalid.', hu: 'Az eszközhitelesítés érvénytelen.' },
  invalid_display_name: { en: 'Enter a valid display name.', hu: 'Adjon meg érvényes megjelenítési nevet.' },
  invalid_lease_period: {
    en: 'The lease period is outside the supported range.',
    hu: 'A licencbérlet időtartama kívül esik a támogatott tartományon.',
  },
  invalid_licence_id: { en: 'The licence identifier is invalid.', hu: 'A licencazonosító érvénytelen.' },
  invalid_limits: { en: 'One or more licence limits are invalid.', hu: 'Egy vagy több licenckorlát érvénytelen.' },
  invalid_organisation_status: {
    en: 'Choose a valid organisation status.',
    hu: 'Válasszon érvényes szervezeti állapotot.',
  },
  invalid_plan: { en: 'Choose a valid licence plan.', hu: 'Válasszon érvényes licenccsomagot.' },
  invalid_public_origin: {
    en: 'The configured public origin is invalid.',
    hu: 'A beállított nyilvános cím érvénytelen.',
  },
  invalid_refresh_token: {
    en: 'The session refresh token is invalid.',
    hu: 'A munkamenet-frissítő token érvénytelen.',
  },
  invalid_signing_key: { en: 'The signing key is invalid.', hu: 'Az aláírókulcs érvénytelen.' },
  licence_assigned: { en: 'The licence is already assigned.', hu: 'A licenc már hozzá van rendelve.' },
  licence_changed: {
    en: 'The licence changed. Reload the list and try again.',
    hu: 'A licenc időközben megváltozott. Frissítse a listát, majd próbálja újra.',
  },
  login_required: { en: 'Sign in to continue.', hu: 'A folytatáshoz jelentkezzen be.' },
  membership_not_active: { en: 'The organisation membership is not active.', hu: 'A szervezeti tagság nem aktív.' },
  not_published: { en: 'Publish the content first.', hu: 'Először tegye közzé a tartalmat.' },
  organisation_ambiguous: {
    en: 'More than one organisation is available. Select an organisation.',
    hu: 'Több szervezet érhető el. Válasszon szervezetet.',
  },
  organisation_membership_required: {
    en: 'An active organisation membership is required.',
    hu: 'Aktív szervezeti tagság szükséges.',
  },
  signing_key_unavailable: { en: 'The signing key is unavailable.', hu: 'Az aláírókulcs nem érhető el.' },
  signing_not_configured: { en: 'Signing is not configured.', hu: 'Az aláírás nincs beállítva.' },
  unknown_product: { en: 'The product is not available.', hu: 'A termék nem érhető el.' },
  admin_portal_access_required: {
    en: 'This account does not have access to the Licence Control administration site.',
    hu: 'Ez a fiók nem rendelkezik hozzáféréssel a Licence Control adminisztrációs felületéhez.',
  },
  admin_portal_forbidden: {
    en: 'This account does not have the required administration role.',
    hu: 'Ez a fiók nem rendelkezik a szükséges adminisztrátori szerepkörrel.',
  },
  admin_role_required: {
    en: 'Select at least one administration role.',
    hu: 'Legalább egy adminisztrátori szerepkört válasszon.',
  },
  admin_user_not_found: {
    en: 'Administration user was not found.',
    hu: 'Az adminisztrációs felhasználó nem található.',
  },
  invalid_admin_status: {
    en: 'Choose a valid administration-user status.',
    hu: 'Válasszon érvényes adminisztrációs felhasználói állapotot.',
  },
  enterprise_only_for_customer_admin: {
    en: 'Organisation licence administrators can issue Enterprise licences only.',
    hu: 'A szervezeti licencadminisztrátorok csak Enterprise licenceket adhatnak ki.',
  },
  delete_dependencies: {
    en: 'This record has dependent records. Delete or reassign them first.',
    hu: 'A rekordhoz további rekordok kapcsolódnak. Először törölje vagy rendelje át őket.',
  },
  restore_parent_unavailable: {
    en: 'Restore and activate the parent record first.',
    hu: 'Először állítsa vissza és aktiválja a szülőrekordot.',
  },
  assignment_deleted: {
    en: 'This assignment was deleted. Restore it from Show deleted.',
    hu: 'A hozzárendelés törölve lett. A Töröltek mutatása nézetből állítsa vissza.',
  },
  qr_restore_forbidden: {
    en: 'A retired QR code cannot be restored or reused.',
    hu: 'A kivont QR-kód nem állítható vissza és nem használható újra.',
  },
  report_single_project_required: {
    en: 'Select tickets from one project.',
    hu: 'Egy projekt hibajegyeit válassza ki.',
  },
  report_evidence_missing: {
    en: 'Report evidence is missing. Check the source attachments.',
    hu: 'A jelentéshez szükséges bizonyíték hiányzik. Ellenőrizze a csatolmányokat.',
  },
  report_ticket_unavailable: {
    en: 'A selected ticket is unavailable. Refresh the selection.',
    hu: 'Egy kiválasztott hibajegy nem érhető el. Frissítse a kijelölést.',
  },
  admin_access_removed: {
    en: 'Web administration access has been removed.',
    hu: 'A webes adminisztrációs hozzáférés megszűnt.',
  },
  licence_must_be_revoked: { en: 'Only revoked licences can be deleted.', hu: 'Csak visszavont licencek törölhetők.' },
  project_access_invalid: { en: 'Choose a valid project access mode.', hu: 'Válasszon érvényes projekthozzáférést.' },
  membership_changed: {
    en: 'This user was changed by another administrator. Reload before saving.',
    hu: 'A felhasználót másik adminisztrátor módosította. Mentés előtt töltse újra.',
  },
  version_required: {
    en: 'Reload the user before saving project access.',
    hu: 'A projekthozzáférés mentése előtt töltse újra a felhasználót.',
  },
  report_worker_unavailable: {
    en: 'Report processing is unavailable. Try again later.',
    hu: 'A jelentéskészítő nem érhető el. Próbálja később.',
  },
  report_queue_full: {
    en: 'Ten reports are already active. Wait or stop one.',
    hu: 'Már tíz jelentés várakozik vagy készül. Várjon, vagy állítson le egyet.',
  },
  report_timeout: {
    en: 'The report exceeded its time limit. Select fewer tickets and try again.',
    hu: 'A jelentés túllépte az időkorlátot. Válasszon kevesebb hibajegyet.',
  },
  report_cancelled: { en: 'Report generation was stopped.', hu: 'A jelentéskészítés leállítva.' },
  report_cancel_forbidden: {
    en: 'Only the requester or an administrator may stop this report.',
    hu: 'A jelentést csak a kérője vagy a szervezeti adminisztrátor állíthatja le.',
  },
  report_render_failed: {
    en: 'Report generation failed. Contact your administrator with the report ID.',
    hu: 'A jelentéskészítés sikertelen. Adja meg a jelentésazonosítót a rendszergazdának.',
  },
  report_worker_interrupted: { en: 'The report worker was interrupted.', hu: 'A jelentéskészítő működése megszakadt.' },
  report_expired: { en: 'The report has expired. Generate a new report.', hu: 'A jelentés lejárt. Készítsen újat.' },
  report_access_removed: { en: 'Report access was removed.', hu: 'A jelentéskészítési jogosultság megszűnt.' },
  invalid_request: { en: 'Check the submitted fields.', hu: 'Ellenőrizze a megadott mezőket.' },
};
